<script setup>
import { Link } from '@inertiajs/vue3'
import { show } from '@/actions/App/Http/Controllers/ProjectController'

defineProps({
    project: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <article
        :key="project.id"
        class="group relative overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-200 transition-all duration-300"
    >
        <div class="relative aspect-4/3 overflow-hidden bg-gray-100">
            <img
                :src="project.thumbnail_2x"
                :alt="project.name"
                class="size-full object-cover"
            />

            <div
                class="bg-brand-primary/0 group-hover:bg-brand-primary/10 absolute inset-0 transition-colors duration-300"
            />

            <div
                v-if="project.service"
                class="absolute top-4 left-4"
            >
                <span
                    class="bg-brand-primary inline-flex items-center rounded-full px-3 py-1.5 text-xs font-semibold text-white shadow-lg"
                >
                    {{ project.service.name }}
                </span>
            </div>
        </div>

        <div class="p-5">
            <p class="mb-2 text-xs font-medium text-gray-400">
                {{ project.published_at_formatted }}
            </p>

            <h3 class="group-hover:text-brand-primary text-lg font-bold text-gray-900 transition-colors">
                <Link
                    :href="show(project.slug)"
                    :aria-label="'Zobrazit projekt ' + project.name"
                >
                    <span class="absolute inset-0" />
                    {{ project.name }}
                </Link>
            </h3>

            <p
                v-if="project.description"
                class="mt-2 line-clamp-2 text-sm leading-relaxed text-gray-600"
            >
                {{ project.description }}
            </p>
        </div>
    </article>
</template>
